module.exports = __webpack_public_path__ + "static/media/reports-list.16e22018.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/manual/reports-list.jpg
// module id = 1927
// module chunks = 0